module.exports = __webpack_public_path__ + "static/p22-0c638b3ba9874761c9c8736baa903632.jpg";